import { Component, Input, Output, AfterViewInit, EventEmitter, OnInit, ViewChild, ElementRef} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { LoaderService } from '../../../app/services/loader.service';
import { AppHelperService } from '../../../app/services/app-helper.service';
import { AssignmentViewService } from '../../services/assignment-view.service';
import { ContentHelper } from 'libs-content-helper';
import { ProductTocService } from 'modules/shared-postlogin/services/product-toc.service';
import { ProductViewHelperService } from 'modules/shared-postlogin/services/product-view-helper.service';
import { ContentAccessService } from 'modules/teacher/services/content-access.service';
import { GradeActivitySelectionService } from 'modules/teacher/services/grade-activity-selection.service';
import { LTIAssignmentsSharedService } from 'modules/teacher/services/lti-assignments-shared.service';

declare var $: any;

@Component({
    selector: 'assignment-path',
    templateUrl: './assignment-path.template.html',
    styleUrls: ['./assignment-path.style.scss'],
    standalone: false
})
export class AssignmentPath implements OnInit {

  showSetRulePageSubscription: Subscription;
  resetTocSelectionSubscription: Subscription;
  leaveSetRulePageSubscription: Subscription;
  @Input() learningpathVisible : boolean = true;
  @Output() learningpathVisibleChange = new EventEmitter<boolean>();
  @Input() noOfCheckedItems : number = 0;
  @Output() noOfCheckedItemsChange = new EventEmitter<number>();
  @Input() tocArray : any[];
  @Output() tocArrayChange = new EventEmitter<any[]>();
  @Input() selectedItem : any;
  @Input() productMeta : any;
  @Input() assignmentData  : any;
  @Input() itemsAlreadyAssigned: any;
  @Input() classGroupData: any;
  @Input() classmeta : any;
  @Input() ebookAssignmentFlowParams : any;
  @Input() productBundleDetails: any;
  @Input() orgId: string;
  @Input() spaceId: string;
  @Input() classId: string;
  @Input() ltiDeepLinkingMode: string;
  @Input() createAccessRule: boolean;
  @Input() gradeActivitySelection: boolean;
  @Input() gradebookMeta: any;
  @Input() gradebookColumn: any;
  @Input() showActivity: boolean;
  @Input() ruleInfo: any;
  @Input() isEditMode: boolean;
  @Input() productTocData: any;
  @Input() assignmentsLOCount: number;
  @Output() showActivityChange = new EventEmitter<boolean>();
  @Output() showActivitySelectionWarningModal = new EventEmitter<boolean>();
  @Output() showActivitySelectionSuccessModal = new EventEmitter<number>();
  @Output() showGenericErrorModal = new EventEmitter<boolean>();
  @Output() showAssignmentLimitWarningModal = new EventEmitter<boolean>();
  @Output() showAssignmentSummaryWarningModal = new EventEmitter<boolean>();

  unitView : boolean = true;
  public contentHelper = ContentHelper;
  activityView : boolean = false;
  tocFolderDepth: number = 0;
  showProductTitle: boolean = true
  previousActivity: any;
  radioButtons: boolean = false;
  public createAccessProducts: any[];
  public totalItemsInProduct: number = 0;
  classProduct:any;
  selectedTestActivities:any = [];
  public showSetRulePage: boolean = false;
  public selectedItemsUpdatedAfterInitiation: any = {};
  public isAssignmentEditMode: boolean = false;
  public isUpdateButtonDisabled: boolean = true;
  private subscriptions = new Subscription();
  private maxAssignmentLimit: number = parseInt(ASSIGNMENTS_LIMIT_IN_CLASS);
  private assignmentsLOLimitInClass: number = parseInt(ASSIGNMENTS_LO_LIMIT_IN_CLASS);
  private isAssignmentJourney: boolean = false;
  public isTestTypeComponent: boolean = false;
  /** Copy the current TOC data */
  public currentTocData;
  /** Object to store the Flatten TOC data to compare the content changes in the assignment */
  public currentAssignmentTocData;
  public currentNoOfCheckedItems: number;
  @ViewChild('assignmentsLOLimitWarningModalButton', { static: false }) assignmentsLOLimitWarningModalButton: ElementRef;
  public isMosaicTypeComponent: boolean = false;

  constructor(
    private activatedRoute: ActivatedRoute, 
    private loaderService: LoaderService,
    private router: Router,
    private appHelperService: AppHelperService,
    private assignmentService: AssignmentViewService,
    private productViewHelperService: ProductViewHelperService,
    private productTocService: ProductTocService,
    private contentAccessService: ContentAccessService,
    private gradeActivitySelectionService: GradeActivitySelectionService,
    private ltiAssignmentsSharedService: LTIAssignmentsSharedService
    ) { }

  ngOnInit() {
    if(this.ltiDeepLinkingMode) return;
    this.tocFolderDepth = this.productTocService.getTocNodeCount(this.tocArray);
    this.classProduct = this.productBundleDetails.products.find((product) => product['dls-product'].code === this.productMeta.productcode);
    this.isTestTypeComponent = this.productViewHelperService.isTestTypeComponent(this.classProduct);
    this.isMosaicTypeComponent = this.appHelperService.isMosaicProduct(this.classProduct['dls-product'].code);
    let assignability = this.classProduct.assignability;
    if(!this.gradeActivitySelection && !this.createAccessRule && assignability && assignability['item-limit']) {
      let itemLimit = assignability['item-limit'];
      if(itemLimit === 1) {
        this.radioButtons = true;
      }
    }

    const itemsPresentInExisingAssignment = {};

    // Check if the user is in the assignment journey
    if (this.router.url?.indexOf("/assignments/") !== -1 || this.router.url?.indexOf("/edit-assignment/") !== -1) {
      this.isAssignmentJourney = true;
    }
    if (this.activatedRoute.snapshot.params?.assignmentid && this.router.url?.indexOf("/edit-assignment/") !== -1) {
      this.isEditMode = true;
      const assignmentId = this.activatedRoute.snapshot.params.assignmentid;
      const assignmentEntity = this.productTocData.assignmentData.entities
        .find((entity) => entity.assigned_path_id === assignmentId);
      
      if (assignmentEntity.items?.length) {
        assignmentEntity.items.forEach(item => itemsPresentInExisingAssignment[item['item-code']] = true);
      }
    }

    const rulesMap: any = {};
    let isCompleteProductSelected = false;
    if(this.ruleInfo) {
      this.ruleInfo.entities.forEach(entity => {
        if(entity.type === 'product') {
          isCompleteProductSelected = true;
        } else {
          rulesMap[entity.id] = true;
        }
      });
    }

    const gradedActivitiesMap: any = {};
    if (this.gradebookColumn && this.gradebookColumn.items) {
      this.gradebookColumn.items.forEach(item => {
        if (item.type === 'product') {
          isCompleteProductSelected = true;
        } else {
          gradedActivitiesMap[item['item-code']] = true;
        }
      });
    }
    const isAllActivitiesSelectedForGradeCalc = !this.gradebookColumn || !this.gradebookColumn.data || typeof this.gradebookColumn.data.noOfSelectedItems === 'undefined';
    if(this.tocFolderDepth === 0) {
      this.unitView = false;
      this.activityView = true;
      this.tocArray = this.tocArray.filter((activity) => {
        if (this.gradeActivitySelection && !activity['contributes-to-completion']) return false;
        if(this.itemsAlreadyAssigned[activity['item-code']] && !this.createAccessRule) {
          if (this.isTestTypeComponent || this.isMosaicTypeComponent) {
            if (itemsPresentInExisingAssignment[activity['item-code']]) {
              activity.isDisabled = false;
            } else {
              activity.isDisabled = true;
            }
          } else {
            activity.alreadyAssigned = true;
          }
        }
        if (rulesMap[activity['item-code']] || isCompleteProductSelected ||
          (this.gradeActivitySelection && (gradedActivitiesMap[activity['item-code']] || isAllActivitiesSelectedForGradeCalc)) || (this.isEditMode && itemsPresentInExisingAssignment[activity['item-code']])) {
          this.noOfCheckedItems++;
          activity.isChecked = true;
          if (this.radioButtons && itemsPresentInExisingAssignment[activity['item-code']]) this.previousActivity = activity;
        }
        return true;
      });
      this.totalItemsInProduct = this.tocArray.length;
    }
    else {
      if(this.tocFolderDepth === 1) {
        this.unitView = false;
      }
      this.tocArray.forEach(unit => {
        unit.checkedItems = 0;
        unit.totalItems = 0;
        let unitLessons = [];
        unitLessons = this.productTocService.getLastFolderData(unit);
        unitLessons.forEach(lesson => {
          lesson.checkedItems = 0;
          lesson.itemsDisabled = 0;
          let allItemsAssigned = true;
          if(lesson.items.length === 0) {
            allItemsAssigned = false;
          }
          lesson.items = lesson.items.filter(item => {
              if (this.gradeActivitySelection && !item['contributes-to-completion']) return false;
              this.totalItemsInProduct++;
              unit.totalItems++;
              // If a unit/lesson/product is selected then all the items within that are selected.
              if(rulesMap[item['item-code']] || rulesMap[lesson['item-code']] || rulesMap[unit['item-code']] || isCompleteProductSelected 
                || (this.gradeActivitySelection && (gradedActivitiesMap[item['item-code']] || gradedActivitiesMap[lesson['item-code']] || gradedActivitiesMap[unit['item-code']] || isAllActivitiesSelectedForGradeCalc)) || (this.isEditMode && itemsPresentInExisingAssignment[item['item-code']])) {
                this.noOfCheckedItems++;
                lesson.checkedItems++;
                if (this.tocFolderDepth > 1) unit.checkedItems++;
                item.isChecked = true;
                if (this.radioButtons && itemsPresentInExisingAssignment[item['item-code']]) this.previousActivity = item;
              }
              if(!this.itemsAlreadyAssigned[item['item-code']]) {
                allItemsAssigned = false;
              } else {
                if(!this.createAccessRule) {
                  if (this.isTestTypeComponent || this.isMosaicTypeComponent) {
                    item.isDisabled = true;
                    lesson.itemsDisabled++;
                  } else {
                    item.alreadyAssigned = true;
                  }
                }
              }
              if (itemsPresentInExisingAssignment[item['item-code']]) {
                if (this.isTestTypeComponent) {
                  item.isDisabled = false;
                  allItemsAssigned = false;
                }
              }
              return true;
          });
          lesson.isLessonDisabled = (this.createAccessRule || !(this.isTestTypeComponent || this.isMosaicTypeComponent)) ? false : allItemsAssigned;
          lesson.showPreviousAssignedText = !(this.isTestTypeComponent || this.isMosaicTypeComponent) && allItemsAssigned;
        })
      })
    }

    if(this.ruleInfo) {
      this.productViewHelperService.showSetRulePageSubject.next({
        isVisible: true,
        totalCheckedItems: this.noOfCheckedItems, 
        totalItemsInProduct: this.totalItemsInProduct
      });
    }

    const isMQASchool = this.orgId.indexOf("mqa") === 0;

    this.createAccessProducts = this.contentAccessService.getCreateAccessComponents(this.classmeta, this.productBundleDetails['bundle-code'], isMQASchool);
    // Event to set rule page
    this.showSetRulePageSubscription = this.productViewHelperService.showSetRulePageSubject.subscribe(data => {
      this.showSetRulePage = data.isVisible;
    });

    this.subscriptions.add(
      this.assignmentService.assignmentCreationState.subscribe((res) => {
        // Event for resetting the TOC to original after clicking on Back to summary page button
        if (res.resetToc) {
          this.resetTheAssignmentDataToOriginal();
        }
        // Edit Assignment event subscription
        this.isAssignmentEditMode = !!res.isEditMode;
        if (res.isEditMode) {
          this.currentTocData = JSON.parse(JSON.stringify(this.tocArray));
          this.currentAssignmentTocData = this.flattenTOCArrayToObject();
          this.currentNoOfCheckedItems = this.noOfCheckedItems;
        }
      })
    );

    //Reset toc in case of new another rule
    this.resetTocSelectionSubscription = this.productViewHelperService.resetTocSelectionSubject.subscribe(val => {
      if(val) this.clearSelectionForCreateAccess(true);
    });

    //For navigating back after leaving the create/update rule page without creating/updating the rule.
    this.leaveSetRulePageSubscription = this.productViewHelperService.leaveSetRulePage.subscribe(val => {
      this.navigateBack(false);
    });
  }

  ngAfterViewInit() {
    this.subscriptions.add(
      this.assignmentService.updateClassDetailsEvent.subscribe((data) => {
        this.classmeta.class.enddate = data.endDate;
        this.classmeta.class.isClassEnded = data.isClassEnded;
      })
    );
  }

  /* NEMO-4752 - Code is not generic for n-folder levels */
  generateLessonData() {
    if (this.tocFolderDepth === 1) {
      return this.tocArray;
    }
    if (this.tocFolderDepth > 1) {
      return this.tocArray[this.selectedItem.selectedUnitIndex].items;
    }
  }

  toggleSideBar() {
    return this.ltiAssignmentsSharedService.toggleSideBar(this);
  }
  launchActivity(activityItem) {
    return this.ltiAssignmentsSharedService.launchActivity(activityItem, this);
  }

  changeCardBgColor(event) {
    return this.ltiAssignmentsSharedService.changeCardBgColor(event, this);
  }
  startLoader() {
    return this.ltiAssignmentsSharedService.startLoader(this);
  }

  public setAssignment(editCurrentAssignment = false) {
    //show assignment limit reached modal, if assignment count is greater/equal to the max assignment limit
    if (!editCurrentAssignment && this.assignmentService.totalAssignmentCount >= this.maxAssignmentLimit) {
      this.showAssignmentLimitWarningModal.emit(true);
      return;
    }

    this.noOfCheckedItemsChange.emit(this.noOfCheckedItems);
    this.tocArrayChange.emit(this.tocArray);
    this.showActivityChange.emit(false);
    const creationStateObject = {
      isAssignDetailCompShown: true,
      isEditMode: false,
      resetToc: false,
      showSuccessBanner: false,
      navigateToAssignmentSummaryOrDetailsPage: true
    };
    this.tocFolderDepth > 1 && (this.unitView = true);

    if (editCurrentAssignment) {
      creationStateObject.showSuccessBanner = true;
      // Clear the selected items after setting the assignment
      this.clearTheAssignmentDataObject();
    }
    this.assignmentService.assignmentCreationState.next(creationStateObject);
  }

  markItemsCheckBoxState(valueToBeSet: boolean, lessonItem: any, unit:any) {
    for (const item of lessonItem.items ) {
      if(!item.isDisabled) {
        if (!item.isChecked && valueToBeSet) {
          if (this.showSetRulePage || this.gradeActivitySelection) {
            if (this.selectedItemsUpdatedAfterInitiation[item['item-code']]) {
              delete this.selectedItemsUpdatedAfterInitiation[item['item-code']];
            } else {
              this.selectedItemsUpdatedAfterInitiation[item['item-code']] = 'added';
            }
          }
          this.noOfCheckedItems += 1;
          if (this.tocFolderDepth > 0) lessonItem.checkedItems++;
          if (this.tocFolderDepth > 1) unit.checkedItems += 1;
        }
        if (item.isChecked && !valueToBeSet) {
          // Update assignment LO count if user is in assignment journey
          if (this.isAssignmentJourney) {
            this.assignmentsLOCount--;
          }
          if (this.showSetRulePage || this.gradeActivitySelection) {
            if (this.selectedItemsUpdatedAfterInitiation[item['item-code']]) {
              delete this.selectedItemsUpdatedAfterInitiation[item['item-code']];
            } else {
              this.selectedItemsUpdatedAfterInitiation[item['item-code']] = 'removed';
            }
          }
          this.noOfCheckedItems -= 1;
          if (this.tocFolderDepth > 0) lessonItem.checkedItems--;
          if (this.tocFolderDepth > 1) unit.checkedItems -= 1;
        }
        item.isChecked = valueToBeSet;
      }
      this.showSetRulePage && this.productViewHelperService.itemsUpdatedAfterSetRuleInitiationSubject.next(this.selectedItemsUpdatedAfterInitiation);
    }
  }

  handleActivityKeydown(event) {
    if(event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      event.target?.children[0].click();
    }
  }

  handleActivityClick(event) {
    if(event.target.tagName === 'DIV') {
      event.target?.children[0].click();
    }
  }

  onChangeItemCheckBox($event, item, lessonItem, unit) {
    if (this.gradeActivitySelection && this.classmeta.class.isClassEnded) return;
    if ($event.currentTarget.checked) {
      // Check if the current flow is an assignment journey and the assignments LO limit is reached  
      if (this.isAssignmentJourney && this.assignmentsLOCount >= this.assignmentsLOLimitInClass) {
        // Uncheck the checkbox and set the value of isChecked to false
        $event.target.checked = false;
        item.isChecked = false;
        // Trigger the warning modal to notify the user about the limit  
        this.assignmentsLOLimitWarningModalButton.nativeElement.click();
        return;
      }

      // Increment the assignments LO count if it is an assignment journey  
      if (this.isAssignmentJourney) this.assignmentsLOCount++;

      if(this.showSetRulePage || this.gradeActivitySelection) {
        if(this.selectedItemsUpdatedAfterInitiation[item['item-code']]) {
          delete this.selectedItemsUpdatedAfterInitiation[item['item-code']];
        } else {
          this.selectedItemsUpdatedAfterInitiation[item['item-code']] = 'added';
        }
      }
      this.noOfCheckedItems++;
      lessonItem.checkedItems++;
      if (this.tocFolderDepth > 1) unit.checkedItems++;
    } else {
      if(this.showSetRulePage || this.gradeActivitySelection) {
        if(this.selectedItemsUpdatedAfterInitiation[item['item-code']]) {
          delete this.selectedItemsUpdatedAfterInitiation[item['item-code']];
        } else {
          this.selectedItemsUpdatedAfterInitiation[item['item-code']] = 'removed';
        }
      }

      // Decrease the LO Count
      if (this.isAssignmentJourney) this.assignmentsLOCount--;
      this.noOfCheckedItems--;
      lessonItem.checkedItems--;
      if (this.tocFolderDepth > 1) unit.checkedItems--;
    }
    this.showSetRulePage && this.productViewHelperService.itemsUpdatedAfterSetRuleInitiationSubject.next(this.selectedItemsUpdatedAfterInitiation);
    // Check if the assignment content has changed, to enable the update button
    if (this.isAssignmentEditMode) {
      this.isAssignmentContentChanged();
    }
  }

  selectLessonAllItems($event, lessonItem, unit) {
    this.ltiAssignmentsSharedService.selectLessonAllItems($event, lessonItem, unit, this);
    if (this.isAssignmentEditMode) {
      this.isAssignmentContentChanged();
    }
  }

  handleSelectUnitAllLessonsKeydown(event) {
    event.preventDefault();
    event.target?.children[0].click();
  }

  // For selecting all the lessons of a unit
  selectUnitAllLessons($event, unit) {
    this.ltiAssignmentsSharedService.selectUnitAllLessons($event, unit, this);
    if (this.isAssignmentEditMode) {
      this.isAssignmentContentChanged();
    }
  }

  handleSelectAllUnitAllLessonsKeydown(event) {
    event.preventDefault();
    event.target?.children[0].click();
  }

  // For selecting all the units of a product
  selectAllUnitAllLessons($event) {
    return this.ltiAssignmentsSharedService.selectAllUnitAllLessons($event, this);
  }

  // Function to handle radio button when assignment limit set to 1.
  onChangeItemRadio($event, activity) {
    if(this.previousActivity) {
      this.previousActivity.isChecked = false;
      if (!this.previousActivity.isDisabled) this.assignmentsLOCount--; 
    }

    // Check if the current flow is an assignment journey and the assignments LO limit is reached  
    if (this.isAssignmentJourney && this.assignmentsLOCount >= this.assignmentsLOLimitInClass) {
      // Uncheck the checkbox and set the value of isChecked to false
      $event.target.checked = false;
      activity.isChecked = false;
      // Trigger the warning modal to notify the user about the limit  
      this.assignmentsLOLimitWarningModalButton.nativeElement.click();
      return;
    }

    if($event.currentTarget.checked) {
      activity.isChecked = true;
      this.noOfCheckedItems = 1;
      this.assignmentsLOCount++;
    }
    else {
      activity.isChecked = false;
    }
    this.previousActivity = activity;
    // Check if the assignment content has changed, to enable the update button
    if (this.isAssignmentEditMode) {
      this.isAssignmentContentChanged();
    }
  }

  /* Function used when single level item check box is clicked. */
  selectActivityinActivityView($event, activity) {
    if (this.gradeActivitySelection && this.classmeta.class.isClassEnded) return;
    if($event.currentTarget.checked) {
      // Check if the current flow is an assignment journey and the assignments LO limit is reached  
      if (this.isAssignmentJourney && this.assignmentsLOCount >= this.assignmentsLOLimitInClass) {
        // Uncheck the checkbox and set the value of isChecked to false
        $event.target.checked = false;
        activity.isChecked = false;
        // Trigger the warning modal to notify the user about the limit  
        this.assignmentsLOLimitWarningModalButton.nativeElement.click();
        return;
      }

      // Increment the assignments LO count if it is an assignment journey  
      if (this.isAssignmentJourney) this.assignmentsLOCount++;

      this.noOfCheckedItems++;
      activity.isChecked = true;
      if (this.showSetRulePage || this.gradeActivitySelection) {
        if (this.selectedItemsUpdatedAfterInitiation[activity['item-code']]) {
          delete this.selectedItemsUpdatedAfterInitiation[activity['item-code']];
        } else {
          this.selectedItemsUpdatedAfterInitiation[activity['item-code']] = 'added';
        }
      }
    }
    else {
      // Decrease the LO Count
      if (this.isAssignmentJourney) this.assignmentsLOCount--;

      this.noOfCheckedItems--;
      activity.isChecked = false;
      if (this.showSetRulePage || this.gradeActivitySelection) {
        if (this.selectedItemsUpdatedAfterInitiation[activity['item-code']]) {
          delete this.selectedItemsUpdatedAfterInitiation[activity['item-code']];
        } else {
          this.selectedItemsUpdatedAfterInitiation[activity['item-code']] = 'removed';
        }
      }
    }

    // Check if the assignment content has changed, to enable the update button
    if (this.isAssignmentEditMode) {
      this.isAssignmentContentChanged();
    }
    this.showSetRulePage && this.productViewHelperService.itemsUpdatedAfterSetRuleInitiationSubject.next(this.selectedItemsUpdatedAfterInitiation);
  }

  private getSelectedItems() {
    const entities = [];
    const updatedActivityList = item => {
      entities.push({
        'item-code': item['item-code'],
        'type': item['item-type']
      });
    }
    if (this.noOfCheckedItems === this.totalItemsInProduct) {
      updatedActivityList({
        'item-code': this.productMeta.productcode,
        'item-type': 'product'
      });
    } else {
      if (this.tocFolderDepth === 0) {
        this.tocArray.forEach((item) => {
          if (item.isChecked) {
            updatedActivityList(item);
          }
        });
      }
      else {
        this.tocArray.forEach(unit => {
          if (unit.checkedItems !== 0 && unit.checkedItems === unit.totalItems) {
            updatedActivityList(unit);
          } else {
            const unitLessons = this.productTocService.getLastFolderData(unit);
            unitLessons.forEach(lesson => {
              if (lesson.checkedItems !== 0 && lesson.checkedItems === lesson.items.length) {
                updatedActivityList(lesson);
              } else {
                lesson.items.forEach(item => {
                  if (item.isChecked) {
                    updatedActivityList(item);
                  }
                })
              }
            });
          }
        });
      }
    }
    return entities;
  }
  
  /* TO BE REMOVED IF NEMO-1277 is discarded
  public isAbsoluteUrl(url) {
    let pat = /(^https?:\/\/)|(^\/\/)/i;
    return pat.test(url);
  }*/

  private getRouteParams() {
    let {spaceid, classid, productcode} = this.activatedRoute.snapshot.params;
    return {spaceId:spaceid, classId: classid, productcode: productcode}
  }

  navigateToClassReviewAssignmentPage(params) {
    this.appHelperService.navigateToClassApp(['teacher', params['spaceId'], 'class', params['classId'], 'view', 'assignments']);
  }

  // Function to navigate to review assignment page in class
  cancelAssignment() {
    if (this.ebookAssignmentFlowParams) {
      this.appHelperService.navigateToFOC(this.ebookAssignmentFlowParams);
    } else {
      const routeParams = this.getRouteParams();
      this.navigateToClassReviewAssignmentPage(routeParams);
    }
  }

  public goBackToAssignmentSummaryPage() {
    this.assignmentService.assignmentCreationState.next({
      isAssignDetailCompShown: true,
      resetToc: true,
      navigateToAssignmentSummaryOrDetailsPage: true
    });
  }

  /**
   * Trigger the assignment summary confirmation modal.
   * Emits the event to the parent component activity-renderer.
   */
  public triggerAssignmentSummaryConfirmationModal() {
    this.showAssignmentSummaryWarningModal.emit(true);
  }

  // Navigate to class app based on no of assignable components.
  navigateBack(isTocBack = true, options?) {
    const routeParams = this.getRouteParams();
    if (this.isEditMode) {
      // If changes are made in assignment edit mode, show confirmation modal
      if (!this.isUpdateButtonDisabled) {
        this.triggerAssignmentSummaryConfirmationModal();
      } else {
        this.goBackToAssignmentSummaryPage();
      }
      return;
    }

    if (this.createAccessRule) {
      if(isTocBack && this.createAccessProducts.length > 1) {
        this.appHelperService.navigateToClassApp(['teacher', routeParams['spaceId'], 'class', routeParams['classId'], 'bundle',this.productBundleDetails['bundle-code'], 'manage-access', 'create']);
      } else {
        this.appHelperService.navigateToClassApp(['teacher', routeParams['spaceId'], 'class', routeParams['classId'], 'bundle',this.productBundleDetails['bundle-code'], 'manage-access']);
      }
    } else if(this.gradeActivitySelection) {
      if(isTocBack || (!isTocBack && !this.isContentModified())) {
        this.appHelperService.navigateToClassApp(['teacher', routeParams['spaceId'], 'class', routeParams['classId'], 'grade-weighting']);
      } else {
        this.showActivitySelectionWarningModal.emit();
      }
    } else {
      const urlOptions = {
        queryParams: {
          fwd: 'false'
        }
      }
      if (options && options.ebookAssignmentFlowParams) {
        urlOptions.queryParams = { ...options.ebookAssignmentFlowParams, ...urlOptions.queryParams};
      }
      if (options && options.ebookAssignmentFlowParams && (options.ebookAssignmentFlowParams["directToEbook"] == "true")) {
        this.appHelperService.navigateToFOC(options.ebookAssignmentFlowParams);
      } else {
        this.appHelperService.navigateToClassApp(['teacher', routeParams['spaceId'], 'class', routeParams['classId'], 'create', 'assignments', 'bundle', this.productBundleDetails['bundle-code']], urlOptions);
      }
    }
    return true;
  }

  cancelSelectionForCreateAccess() {
    const routeParams = this.getRouteParams();
    this.appHelperService.navigateToClassApp(['teacher', routeParams['spaceId'], 'class', routeParams['classId'], 'bundle',this.productBundleDetails['bundle-code'], 'manage-access']);
  }

  clearSelectionForCreateAccess(isTocReset = false) {
    this.noOfCheckedItems = 0;
    if(this.tocFolderDepth === 0) {
      this.tocArray.forEach((activity) => {
        if(activity.isChecked) {
          if((this.showSetRulePage || this.gradeActivitySelection) && !isTocReset) {
            if(this.selectedItemsUpdatedAfterInitiation[activity['item-code']] === 'added') {
              delete this.selectedItemsUpdatedAfterInitiation[activity['item-code']];
            } else {
              this.selectedItemsUpdatedAfterInitiation[activity['item-code']] = 'removed';
            }
          }
          activity.isChecked = false;
        }
      })
    }
    else {
      this.tocArray.forEach(unit => {
        unit.checkedItems = 0;
        let unitLessons = [];
        unitLessons = this.productTocService.getLastFolderData(unit);
        unitLessons.forEach(lesson => {
          lesson.checkedItems = 0;
          lesson.items.forEach(item => {
            if(item.isChecked) {
              if((this.showSetRulePage  || this.gradeActivitySelection) && !isTocReset) {
                if(this.selectedItemsUpdatedAfterInitiation[item['item-code']] === 'added') {
                  delete this.selectedItemsUpdatedAfterInitiation[item['item-code']];
                } else {
                  this.selectedItemsUpdatedAfterInitiation[item['item-code']] = 'removed';
                }
              }
              item.isChecked = false;
            }
          });
        })
      })
    }
    if(!isTocReset && this.showSetRulePage) this.productViewHelperService.itemsUpdatedAfterSetRuleInitiationSubject.next(this.selectedItemsUpdatedAfterInitiation)
  }

  launchSetRulePage() {
    if(this.showActivity) {
      this.showActivity = false;
      this.showActivityChange.emit(this.showActivity);
    }
    this.productViewHelperService.showSetRulePageSubject.next({
      isVisible: true,
      totalCheckedItems: this.noOfCheckedItems, 
      totalItemsInProduct: this.totalItemsInProduct
    });
  }

  revertModificationChanges() {
    if (this.gradeActivitySelection && this.classmeta.class.isClassEnded) return;  
    if(this.tocFolderDepth === 0) {
      this.tocArray = this.tocArray.filter((activity) => {
        if(this.selectedItemsUpdatedAfterInitiation[activity['item-code']] === 'added') {
          this.noOfCheckedItems -= 1;
          activity.isChecked = false;
        } else if (this.selectedItemsUpdatedAfterInitiation[activity['item-code']] === 'removed') {
          this.noOfCheckedItems += 1;
          activity.isChecked = true;
        }
        return true;
      });
    }
    else {
      this.tocArray.forEach(unit => {
        const unitLessons = this.productTocService.getLastFolderData(unit);
        unitLessons.forEach(lesson => {
          lesson.items.forEach(item => {
            if(this.selectedItemsUpdatedAfterInitiation[item['item-code']] === 'added') {
              this.noOfCheckedItems -= 1;
              lesson.checkedItems--;
              if (this.tocFolderDepth > 1) unit.checkedItems -= 1;
              item.isChecked = false;
            } else if (this.selectedItemsUpdatedAfterInitiation[item['item-code']] === 'removed') {
              this.noOfCheckedItems += 1;
              lesson.checkedItems++;
              if (this.tocFolderDepth > 1) unit.checkedItems += 1;
              item.isChecked = true;
            }
            return true;
          });
        })
      });
    }
    this.selectedItemsUpdatedAfterInitiation = {};
    this.showSetRulePage && this.productViewHelperService.itemsUpdatedAfterSetRuleInitiationSubject.next(this.selectedItemsUpdatedAfterInitiation);
  }

  isContentModified() {
    return Object.keys(this.selectedItemsUpdatedAfterInitiation).length > 0; 
  }

  updateContentAccessItems() {
    // Close learningPath when content is updated and if width lies in the range of mobile screens
    if (window.innerWidth < 576) {
      this.learningpathVisible = false;
      this.learningpathVisibleChange.emit(this.learningpathVisible);
    }
    this.productViewHelperService.showContentAccessItemsUpdatedMsg.next(true);
    setTimeout(() => {
      this.productViewHelperService.showContentAccessItemsUpdatedMsg.next(false);
    }, 10000);
    this.selectedItemsUpdatedAfterInitiation = {};
    this.showSetRulePage && this.productViewHelperService.itemsUpdatedAfterSetRuleInitiationSubject.next(this.selectedItemsUpdatedAfterInitiation);
    
    if (this.noOfCheckedItems && this.showActivity) {
      this.showActivity = false;
      this.showActivityChange.emit(this.showActivity);
    }

    this.productViewHelperService.showSetRulePageSubject.next({
      isVisible: this.noOfCheckedItems === 0 ? false : true,
      totalCheckedItems: this.noOfCheckedItems, 
      totalItemsInProduct: this.totalItemsInProduct,
      isUpdateView: true
    });
  }

  cancelChanges() {
    if (this.gradeActivitySelection && this.classmeta.class.isClassEnded) return;
    if(this.showSetRulePage) {
      this.revertModificationChanges();
    } else if (this.gradeActivitySelection) {
      if (!this.isContentModified()) this.navigateBack(true);
      else this.showActivitySelectionWarningModal.emit(true);
    } else {
      this.cancelSelectionForCreateAccess();
    }
  }

  public saveActivitySelection() {
    if (this.gradeActivitySelection && this.classmeta.class.isClassEnded) return;
    const params: any = {
      createGradebook: this.gradebookMeta ? false : true,
    };
    if (this.gradebookColumn) {
      params.updateColumn = [{
        'column_id': this.gradebookColumn['column_id'],
        'items': this.getSelectedItems(),
        'data': {
          'noOfSelectedItems': this.noOfCheckedItems
        }
      }];
    } else {
      params.createColumn = [{
        'column_id': this.productMeta.productcode,
        'type': 'product',
        'bundle-codes': this.productMeta['bundle-codes'],
        'productcode': this.productMeta.productcode,
        'items': this.getSelectedItems(),
        'data': {
          'noOfSelectedItems': this.noOfCheckedItems
        }
      }];
    }
    this.loaderService.showOverlayLoader();
    this.subscriptions.add(this.gradeActivitySelectionService.saveGradeActivitySelection(this.spaceId, this.classId, params).subscribe((res: any) => {
      this.noOfCheckedItemsChange.emit(this.noOfCheckedItems);
      // Close learningPath when content is updated and if width lies in the range of mobile screens
      if (window.innerWidth < 576) {
        this.learningpathVisible = false;
        this.learningpathVisibleChange.emit(this.learningpathVisible);
      }
      this.showActivitySelectionSuccessModal.emit(this.totalItemsInProduct);
      this.selectedItemsUpdatedAfterInitiation = {};
      this.loaderService.hideLoader();
    }, _error => {
      this.showGenericErrorModal.emit(true);
      this.loaderService.hideLoader();
    }));
  }

  /**
   * Flattens the Table of Contents (TOC) array into an object.
   * 
   * This method iterates through the `tocArray` and recursively processes each unit
   * to extract all levels of TOC data. The resulting object contains the `item-code`
   * as keys, and each key maps to an object with `checkedItems` and `isChecked` properties.
   * 
   * @returns {Object} An object representing the flattened TOC data.
   */
  private flattenTOCArrayToObject() {
    const currentAssignmentTocData = {};
    this.tocArray.forEach((unit) => {
      getAllLevelsOfTOCData(unit);
    });
    function getAllLevelsOfTOCData(item) {
      if (item.items) {
        item.items.forEach(item => getAllLevelsOfTOCData(item));
        currentAssignmentTocData[item['item-code']] = {
          checkedItems: item.checkedItems,
          isChecked: item.isChecked
        };
      } else {
        currentAssignmentTocData[item['item-code']] = {
          checkedItems: item.checkedItems,
          isChecked: item.isChecked
        };
      }
    }
    this.isUpdateButtonDisabled = true;
    return currentAssignmentTocData;
  }

  /**
   * Resets the assignment data to its original state.
   * 
   * This method performs the following actions:
   * - Sets `tocArray` to `currentTocData`.
   * - Sets `noOfCheckedItems` to `currentNoOfCheckedItems`.
   * - Clears the assignment data object.
   */
  private resetTheAssignmentDataToOriginal() {
    this.tocArray = this.currentTocData;
    this.noOfCheckedItems = this.currentNoOfCheckedItems;
    this.noOfCheckedItemsChange.emit(this.noOfCheckedItems);
    this.tocArrayChange.emit(this.tocArray);
    this.clearTheAssignmentDataObject();
  }

  /**
   * Clears the assignment data object by resetting the following properties:
   * - `currentTocData` to an empty array
   * - `currentAssignmentTocData` to an empty object
   * - `currentNoOfCheckedItems` to 0
   */
  private clearTheAssignmentDataObject() {
    this.currentTocData = [];
    this.currentAssignmentTocData = {};
    this.currentNoOfCheckedItems = 0;
  }

  /**
   * Checks if the assignment content has changed by comparing the current number of checked items
   * and the current assignment table of contents (TOC) data with the previous state.
   * 
   * If the number of checked items has changed, it enables the update button.
   * Otherwise, it recursively checks all levels of the TOC data to determine if any item has changed.
   * 
   * If any item has changed, it enables the update button and exits early.
   * If no changes are detected, it disables the update button.
   * 
   * @returns {void}
   */
  private isAssignmentContentChanged() {
    // if no items are selected, disable the update button
    if (!this.noOfCheckedItems) {
      this.isUpdateButtonDisabled = true;
      return;
    }

    if (this.currentNoOfCheckedItems !== this.noOfCheckedItems) {
      this.isUpdateButtonDisabled = false;
      return;
    }
    let enableUpdateButton = false;
    const getAllLevelsOfTOCData = (item): boolean => {
      if (item.items) {
        return item.items.some((subItem) => getAllLevelsOfTOCData(subItem));
      }
      return !!item.isChecked !== !!this.currentAssignmentTocData[item['item-code']].isChecked;
    };
    enableUpdateButton = this.tocArray.some((unit) => getAllLevelsOfTOCData(unit));
    if (enableUpdateButton) {
      this.isUpdateButtonDisabled = false;
      return;
    } 
    this.isUpdateButtonDisabled = true;
  }

  ngOnDestroy() {
    if(this.showSetRulePageSubscription) {
      this.showSetRulePageSubscription.unsubscribe();
    }
    if(this.resetTocSelectionSubscription) {
      this.resetTocSelectionSubscription.unsubscribe();
    }
    if(this.leaveSetRulePageSubscription) {
      this.leaveSetRulePageSubscription.unsubscribe();
    }
    this.subscriptions.unsubscribe();
  }
}
